import React from 'react';
import { ShieldCheck, Download, Lock, Star } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: Lock,
    text: 'Pago 100% Seguro'
  }, {
    icon: Download,
    text: 'Acceso Inmediato'
  }, {
    icon: ShieldCheck,
    text: 'Garantía de 7 Días'
  }, {
    icon: Star,
    text: 'Calidad Premium'
  }];
  return <div className="w-full bg-white/50 border-y border-caramel/10 py-6" data-id="element-228">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-230">
          {badges.map((badge, index) => <div key={index} className="flex items-center gap-2 text-espresso-light" data-id="element-231">
              <badge.icon className="w-5 h-5 text-caramel" data-id="element-232" />
              <span className="font-medium text-sm md:text-base" data-id="element-233">
                {badge.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}